import React, {useEffect, useState} from 'react'
import ModalPop from '../modal/modal';
import Loader from "../../Loader/Loader";
import  { Redirect } from 'react-router-dom'

const
    SuccessModal = (
    {
        isOpen = false,
        msg="Saved!",
        url='',
        history
    }
) => {

    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setIsOpen(isOpen)
        setTimeout(() => {
            setIsLoading(true)
            setIsLoading(false)
        }, 500)
    }, [isOpen])

    useEffect(() => {
        if(url !== ''){
            window.localStorage.redirect_url = url
        }
    }, [url])

    function closeModal() {
        setIsOpen(false);
        window.location.reload()

        window.location.href = window.localStorage.redirect_url
        // if(url !== ''){
        //     window.location.replace(url);
        // }
    }

    return (
        <>
            <Loader isLoading={isLoading}/>
            <ModalPop
                title='Success'
                show={modalIsOpen}
                handleModalHide={closeModal}
                keyboard
                backdrop
                url={url}
            >
                <div className="text-center">
                    <div className="success">
                        <img src="./img/success.gif" width="50%" alt="" />

                    </div>
                    <h5>{msg}</h5>
                </div>
            </ModalPop>
        </>
    )
}

export default SuccessModal